import {addDelegateEventListener} from '../helpers';
import {ConfigProvider} from "../config/configProvider";

class BaseClickManager
{
    static get entitySelector() {
        return '[data-list="entity"]';
    }

    static get clickButtonSelector() {
        return '[data-entity="click"]';
    }

    static get storageClickedKey() {
        return 'clickedEntities';
    }

    static get storageClickedShopsKey() {
        return 'clickedShops';
    }

    static get urlParamName() {
        return 'eid';
    }

    /**
     * @param {Element} listContentElement
     */
    static init(listContentElement) {
        let shopId = listContentElement.getAttribute('data-shop-id');

        addDelegateEventListener(
            listContentElement,
            'click',
            this.clickButtonSelector,
            (buttonElement, event) => {
                event.preventDefault();
                this.click(buttonElement, Number(shopId));
            }
        );

        this.checkVisit(listContentElement);
    }

    /**
     * @param {Element} listContentElement
     */
    static checkVisit(listContentElement) {
        let clicked = this.getClicked();
        let lang = ConfigProvider.get('lang');
        let shopId = listContentElement.getAttribute('data-shop-id');
        let clickedShops = this.getClickedShops();
        let shopClicked = false;

        if (lang === 'ca' && clickedShops.length > 0 && clickedShops.includes(Number(shopId))) {
            shopClicked = true;
        }

        let visitedElements = Array.from(listContentElement.querySelectorAll(this.entitySelector)).filter((element) => {
            return shopClicked || clicked.includes(Number(element.getAttribute('data-id')));
        });

        this.markVisited(visitedElements);
    }

    /**
     * @param {Element[]} elements
     */
    static markVisited(elements) {
        elements.forEach((element) => element.classList.add('-visited'));
    }

    /**
     * @param {Element} buttonElement
     * @param {Number} shopId
     * */
    static handleClicked(buttonElement, shopId) {
        let cardElement = buttonElement.closest(this.entitySelector),
            id = cardElement.getAttribute('data-id');

        this.addToClicked(Number(id));
        this.addToClickedShop(Number(shopId));
    }

    /**
     * @param {Element} buttonElement
     * @param {Number} shopId
     *  */
    static click(buttonElement, shopId) {
        this.handleClicked(buttonElement, shopId);
        let href = buttonElement.getAttribute('href');
        let cardElement = buttonElement.closest(this.entitySelector),
            id = cardElement.getAttribute('data-id'),
            removableParams = ['fid', 'oid', 'sid'],
            endpointUrl = null,
            currentUrl = new URL(location.href);

        if (href) {
            endpointUrl = new URL(buttonElement.getAttribute('href'))
        } else {
            endpointUrl = this.createEndpointUrl(buttonElement);
        }

        this.sendAnalytics(cardElement);

        removableParams.forEach((urlParam) => currentUrl.searchParams.delete(urlParam));
        currentUrl.searchParams.set(this.urlParamName, id);

        let refererCategory = document.querySelector('meta[name="referer-category"]');

        if (refererCategory) {
            endpointUrl.searchParams.set('cat', refererCategory.getAttribute('content'));
        }

        if (this.reversePopup(cardElement)) {
            window.open(endpointUrl.href).focus();
            location.href = currentUrl.href;
        } else {
            window.open(currentUrl.href);
            location.href = endpointUrl.href;
        }
    }

    /** @param {Element} cardElement */
    static sendAnalytics(cardElement) {}

    static reversePopup() {
        return false;
    }

    /** @return {Array} */
    static getClicked() {
        let clicked = JSON.parse(localStorage.hasOwnProperty(this.storageClickedKey) ? localStorage.getItem(this.storageClickedKey) : '[]');
        return (clicked && Array.isArray(clicked)) ? clicked : [];
    }

    /** @return {Array} */
    static getClickedShops() {
        let clickedShops = JSON.parse(localStorage.hasOwnProperty(this.storageClickedShopsKey) ? localStorage.getItem(this.storageClickedShopsKey) : '[]');
        return (clickedShops && Array.isArray(clickedShops)) ? clickedShops : [];
    }

    /**
     * @param {Number} id
     * @param {Number} shopId
     */
    static addToClicked(id) {
        let clicked = this.getClicked();

        if (clicked.includes(id)) {
            return;
        }

        clicked.push(id);
        localStorage.setItem(this.storageClickedKey, JSON.stringify(clicked));
    }

    /**
     * @param {Number} id
     */
    static addToClickedShop(id) {
        let clickedShops = this.getClickedShops();

        if (clickedShops.includes(id)) {
            return;
        }

        clickedShops.push(id);
        localStorage.setItem(this.storageClickedShopsKey, JSON.stringify(clickedShops));
    }

    static createEndpointUrl(buttonElement) {
        return new URL(location.href);
    }
}

export {BaseClickManager}
